import { each } from 'lodash';
import Swiper from 'swiper/bundle';
import { x } from '../_helpers';

export default class Carousels {
  constructor() {
    this.carousels = x("[js-carousel]");

    if (this.carousels) {
      this.init();
    }
  }

  initCarousel(el) {
    const carousel = new Swiper(el, {
      speed: 600,
      slidesPerView: el.hasAttribute("js-carousel-gallery") ? 1 : "auto",
      autoplay: el.hasAttribute('js-carousel-autoplay')
        ? {
          delay: 4000,
        }
        : false,
      navigation: {
        nextEl: el.querySelector('[js-carousel-trigger-next]'),
        prevEl: el.querySelector('[js-carousel-trigger-prev]'),
      },
      pagination: {
        el: el.querySelector("[js-carousel-pagination]"),
        type: el.hasAttribute("js-carousel-fraction-pagination")
          ? "fraction"
          : "bullets",
      },
    });
    if (el.hasAttribute("js-carousel-gallery")) {
      this.createGallery(el, carousel);
    }
  }
  createGallery(el, carousel) {
    // ELEMENTS
    const paginationWrapper = el.parentNode.parentNode.querySelector(
      ".swiper-info__pagination"
    );
    const photoWrapper = el.parentNode.parentNode.querySelector(
      ".swiper-wrapper-info .swiper-info__photo"
    );

    const photoWrapperCaption = el.parentNode.parentNode.querySelector(
      ".swiper-wrapper-info-caption .swiper-info__photo-caption"
    );

    const fullscreenWrapper = el.parentNode.parentNode.querySelector(
      ".swiper-info__fullscreen"
    );
    const paginationCurrent = paginationWrapper.querySelector(
      ".swiper-info__pagination--current"
    );
    const paginationTotal = paginationWrapper.querySelector(
      ".swiper-info__pagination--total"
    );
    let photoCaption = photoWrapper
      ? photoWrapper.querySelector(".swiper-info__photo h1")
      : undefined;
    photoCaption = photoCaption ? photoCaption : photoWrapper.querySelector(".swiper-info__photo div");
    const photoDescription = photoWrapperCaption
      ? photoWrapperCaption.querySelector(".swiper-info__photo-caption span")
      : undefined;

    // FULLSCREEN
    fullscreenWrapper.addEventListener("click", () => {
      el.querySelector(".swiper-slide-active a").click();
    });

    // PAGINATION && TEXT
    carousel.on("paginationUpdate", (swiper, paginationEl) => {
      this.setPagination(paginationCurrent, paginationTotal, paginationEl);
    });
    carousel.on("slideChangeTransitionEnd", (swiper) => {
      const target = el.querySelector(".swiper-slide-active a");
      this.setInfo(photoCaption, photoDescription, target);
    });

    // INITIALIZE
    const target = el.querySelector(".swiper-slide-active a");

    this.setInfo(photoCaption, photoDescription, target);
    carousel.pagination.update();
  }

  setPagination(paginationCurrent, paginationTotal, paginationEl) {
    if (paginationCurrent) {
      paginationCurrent.innerHTML = (
        paginationEl.querySelector(".swiper-pagination-current") || {
          innerText: "",
        }
      ).innerText;
    }
    if (paginationTotal) {
      paginationTotal.innerHTML = (
        paginationEl.querySelector(".swiper-pagination-total") || {
          innerText: "",
        }
      ).innerText;
    }
  }

  setInfo(photoCaption, photoDescription, target) {
    if (photoCaption) {
      const caption = target.getAttribute("data-caption");
      photoCaption.innerHTML = caption;
    }
    if (photoDescription) {
      const desc = target.getAttribute("data-desc");
      photoDescription.innerHTML = desc;
    }
  }

  handleEvents() {
    each(this.carousels, (el) => {
      this.initCarousel(el);
    });
  }

  init() {
    this.handleEvents();
  }
}
